export default __webpack_public_path__ + "static/media/image6.2cf22eda.svg";